import { useState } from 'react';
import Button from '../common/Button';
import SectionHeading from '../common/SectionHeading';
import { homeFaqs } from '../../data/faqs';

function FAQPreview() {
  const [openItems, setOpenItems] = useState(() => new Set([homeFaqs[0].question]));

  const toggleItem = (question) => {
    setOpenItems((current) => {
      const next = new Set(current);

      if (next.has(question)) {
        next.delete(question);
      } else {
        next.add(question);
      }

      return next;
    });
  };

  return (
    <section className="faq-preview" aria-labelledby="faq-preview-title">
      <div className="container faq-preview__inner">
        <SectionHeading
          eyebrow="FAQ"
          title="Common repair questions"
          text="A few quick answers for industrial teams looking at repair options."
        />
        <div className="faq-preview__list">
          {homeFaqs.map((item) => {
            const isOpen = openItems.has(item.question);
            const panelId = `faq-${item.question.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '')}`;

            return (
              <article key={item.question} className={`faq-preview__item${isOpen ? ' is-open' : ''}`}>
                <button
                  className="faq-preview__question"
                  type="button"
                  aria-expanded={isOpen}
                  aria-controls={panelId}
                  onClick={() => toggleItem(item.question)}
                >
                  <span>{item.question}</span>
                  <span className="faq-preview__indicator" aria-hidden="true" />
                </button>
                <div id={panelId} className="faq-preview__answer" aria-hidden={!isOpen}>
                  <p>{item.answer}</p>
                </div>
              </article>
            );
          })}
        </div>
        <Button to="/contact">Request a Quote</Button>
      </div>
    </section>
  );
}

export default FAQPreview;
